export default __webpack_public_path__ + "static/media/icon_can_vector.67dd68cb.svg";